/**
 * Snapshot of a real placement-agent run over the Detours script.
 *
 * GENERATED by backend/placement_agent/run_on_script.py --write-frontend.
 * Edits here are overwritten by the next run.
 *
 * A .ts module rather than a .json import on purpose: this project does not set
 * `resolveJsonModule`, so a JSON import type-checks only if that flag is added
 * to the shared tsconfig — not worth it for one demo page.
 *
 * Annotated as PlacementRun rather than left to inference (and NOT `as const`):
 * the page renders this and a live API response with the same code, so both have
 * to be the same type. It also means a field the agent stops emitting fails the
 * frontend build here, instead of rendering as an empty column.
 */
import type { PlacementRun } from "@/types/placement-run";

export const detoursRun: PlacementRun = {
 "script": "Detours",
 "run": {
  "scenes": 13,
  "cost_usd": 0.8241,
  "wall_seconds": 357.3,
  "schema_violations": [],
  "layout_warnings": [],
  "config": {
   "model": "gemini-2.5-pro",
   "votes": 3,
   "keep": 2,
   "workers": 8,
   "seed": 42,
   "iab_selection": "hier_enriched",
   "prompt_bundle": "placement_v3",
   "prompt_version": "3ce7a4dcb2cbc3a4"
  }
 },
 "summary": {
  "content_rating": "TV-14",
  "character_archetypes": [
   "Matriarch",
   "Underdog"
  ],
  "setting": [
   "Suburban",
   "Domestic / Home"
  ],
  "tonal_qualities": [
   "Dysfunctional Family Comedy",
   "Nostalgic / Period"
  ],
  "genre_focus": [
   "Comedy",
   "Family & Relationships"
  ],
  "cultural_markers": [
   "Nostalgic / Retro",
   "Working Class",
   "Americana / Heartland"
  ],
  "total_placements": 76,
  "narrative_integrations": 62,
  "ncc_count": 8
 },
 "placements": [
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "furniture (outdated)",
   "normalized_iab_product": "furniture",
   "iab_category": "1268: Durable Goods > Furniture",
   "integration_type": "Product Placement",
   "integration_type_llm": "Product Placement",
   "segment_suitability": "Neutral",
   "suitability_reason": "The furniture is described as outdated to establish the 1990s setting and the family's un-stylish home. It is a neutral, world-building detail.",
   "integration_density": 6,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "the furniture would look in vogue a decade earlier",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "PRESENT_ONLY",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.025,
   "iab_runner_up": "1196: Consumer Packaged Goods > Household/Plastics/Storage"
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "PICTURE (crooked family photo)",
   "normalized_iab_product": "home and garden products",
   "iab_category": "1277: Durable Goods > Home and Garden Products",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The family picture falls off the wall, serving as a visual punchline to the narrator's description of the 'perfect family'. It is focal to the scene's opening gag.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "The crooked photo on the wall falls to the ground.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0055,
   "iab_runner_up": "1196: Consumer Packaged Goods > Household/Plastics/Storage"
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "CHECK (for the church donation)",
   "normalized_iab_product": "cat",
   "iab_category": "1225: Consumer Packaged Goods > Pet Care > Cat/Dog Litter",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character writes, discusses, voids, and rewrites a check, making it central to a comedic beat about her frugality. The use is functional and drives dialogue.",
   "integration_density": 75,
   "mentions": 5,
   "scene_count": 3,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "writing a CHECK for the church donation basket.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0002,
   "iab_runner_up": "1337: Finance and Insurance > Banking"
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "church donation basket",
   "normalized_iab_product": "charities and donations",
   "iab_category": "1453: Non-Profits > Charities and Donations",
   "integration_type": "Product Placement",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The donation basket is mentioned in dialogue as the reason for writing a check, framing a comedic beat about a character's stinginess.",
   "integration_density": 12,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "check for the donation basket?",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0527,
   "iab_runner_up": "1492: Religion and Spirituality > Religious Charities"
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "hair brush",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The hair brush is a point of contention, mentioned by multiple characters and visually part of a gag when it's seen tangled in a character's hair. It drives a small comedic subplot.",
   "integration_density": 45,
   "mentions": 3,
   "scene_count": 3,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Donna! Where's my hair brush?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0105,
   "iab_runner_up": "1273: Durable Goods > Grooming Supplies > Hair Appliances"
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "CIGARETTE (in Gerry's mouth)",
   "normalized_iab_product": "cigarette",
   "iab_category": "NCC \u2014 Tobacco product",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "A character is introduced with a cigarette in his mouth, establishing his character. This is a non-commercial category placement for a tobacco product.",
   "integration_density": 0,
   "mentions": 1,
   "scene_count": 2,
   "review_flag": "NCC",
   "evidence_span": "CIGARETTE in his mouth.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "PRESENT_ONLY",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "JOINT (pushed into pocket)",
   "normalized_iab_product": "marijuana joint",
   "iab_category": "NCC \u2014 Illegal drug",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "A character hides a joint from his mother, an action that demonstrates his 'stoner' character trait and is focal to the beat. This is an NCC placement for an illegal drug.",
   "integration_density": 0,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "NCC",
   "evidence_span": "He pushes a JOINT deeper into his pocket",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "Benadryl",
   "normalized_iab_product": "over the counter medication",
   "iab_category": "1208: Consumer Packaged Goods > Over the Counter Medication",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "A character suggests another take Benadryl for red eyes, which are actually from being high. The brand is used as a comedic cover for drug use, which is a sensitive context.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Grab a Benadryl off my dresser.",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0013,
   "iab_runner_up": "1521: Sexual Health > Doctor Perscribed Medicines"
  },
  {
   "scene_id": "SC001",
   "page_number": 1,
   "raw_term": "basketball",
   "normalized_iab_product": "sporting goods",
   "iab_category": "1524: Sporting Goods",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Positive",
   "suitability_reason": "A character is seen playing basketball, a positive and active context. The product is used for its intended purpose to establish character.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 2,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "He's playing basketball.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0065,
   "iab_runner_up": "1436: Media > Sports > Sports Highlights"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "a black t-shirt (used as part of a nun habit)",
   "normalized_iab_product": "wedding dresses",
   "iab_category": "1066: Clothing and Accessories > Clothing > Wedding Dresses/Bridal Wear/Tuxedos",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A black t-shirt is used comically as part of a child's homemade nun costume. The usage is neutral and part of the scene's chaotic family comedy.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "a NUN HABIT on his head made out of a black t-shirt",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.014,
   "iab_runner_up": "1194: Consumer Packaged Goods > Hosiery > Socks"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "Jojo's white headband (used as part of a nun habit)",
   "normalized_iab_product": "hair accessories",
   "iab_category": "1180: Consumer Packaged Goods > Hair Care > Hair Accessories",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A white headband is used comically as part of a child's homemade nun costume. The usage is neutral and part of the scene's chaotic family comedy.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Jojo's white headband",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0006,
   "iab_runner_up": "1111: Consumer Electronics > Headphones"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "Sister Act (soundtrack is sung by characters)",
   "normalized_iab_product": "hair styling gel",
   "iab_category": "1185: Consumer Packaged Goods > Hair Care > Hair Styling Gel/Mousse",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "Characters sing a song from the movie 'Sister Act' and the soundtrack is mentioned by name. This is a positive, comedic reference to a well-known film.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT",
   "evidence_span": "singing the Sister Act soundtrack?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0314,
   "iab_runner_up": "1266: Durable Goods > Electronics/Photography > Blank Audio/Video Media"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "a new PINK BRUSH (stuck in Junior's hair)",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A pink hairbrush is part of a comedic gag, first seen with Gerry and later stuck in his son's hair. The usage is harmless and comedic.",
   "integration_density": 45,
   "mentions": 3,
   "scene_count": 3,
   "review_flag": null,
   "evidence_span": "Gerry enters with a new PINK BRUSH",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED|DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0304,
   "iab_runner_up": "1273: Durable Goods > Grooming Supplies > Hair Appliances"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "HAIRSPRAY (accidentally sprayed in Gerry's eyes)",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "Hairspray is used incorrectly, being accidentally sprayed in a character's eyes, causing pain. This is a slapstick moment, but depicts product misuse and minor injury, making it category sensitive.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Donna accidentally sprays the hairspray in Gerry's eyes.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.1038,
   "iab_runner_up": "1273: Durable Goods > Grooming Supplies > Hair Appliances"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "GameBoy (Danster asks to bring it to mass)",
   "normalized_iab_product": "video games",
   "iab_category": "1120: Consumer Electronics > Video Games",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "A character asks to bring his GameBoy to mass and is told no. The context is slightly negative, associating the product with something inappropriate for a religious service, but it's a common parent-child interaction.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|IAB_AMBIGUOUS",
   "evidence_span": "Ma, can I bring my GameBoy?",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0179,
   "iab_runner_up": "1248: Consumer Packaged Goods > Toys and Games"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "Benadryl (Junior takes four pills)",
   "normalized_iab_product": "doctor perscribed medicines",
   "iab_category": "1521: Sexual Health > Doctor Perscribed Medicines",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "A character takes four times the recommended dose of Benadryl, an over-the-counter allergy medication. This is product misuse, even if played for comedy, making it category sensitive for a pharmaceutical brand.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "The Benadryl was outta the box",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0095,
   "iab_runner_up": "1473: Pharmaceuticals"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "A CAR ALARM (goes off, startling Donna)",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A car alarm goes off, startling a character and causing a comedic accident. The alarm functions as a plot device and its use is neutral.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "A CAR ALARM goes off.",
   "votes": "2/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0218,
   "iab_runner_up": "1563: Vehicles > Automotive Services > Car Wash"
  },
  {
   "scene_id": "SC002",
   "page_number": 2,
   "raw_term": "voided church check (being eaten by the dog)",
   "normalized_iab_product": "banking",
   "iab_category": "1337: Finance and Insurance > Banking",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "A check, a financial instrument, is shown being destroyed by a dog. This is a negative context for a financial service.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 3,
   "review_flag": null,
   "evidence_span": "Cuddles is eating the voided church check under the table.",
   "votes": "2/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0445,
   "iab_runner_up": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz"
  },
  {
   "scene_id": "SC003",
   "page_number": 3,
   "raw_term": "MINIVAN (Junior is asleep next to it, its alarm goes off)",
   "normalized_iab_product": "recreational vehicles",
   "iab_category": "1574: Vehicles > Vehicle Type > Recreational Vehicles",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The minivan is the setting for the scene's action. Its alarm is triggered by a basketball, making it an active part of the comedic beat, but the vehicle itself is not portrayed negatively or positively.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "family MINIVAN",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0319,
   "iab_runner_up": "1220: Consumer Packaged Goods > Personal Cleansing > Soap"
  },
  {
   "scene_id": "SC003",
   "page_number": 3,
   "raw_term": "BASKETBALL (thrown at Junior's head)",
   "normalized_iab_product": "sporting goods",
   "iab_category": "1524: Sporting Goods",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "The basketball is used as a projectile to hit a sleeping character in the head. Although the context is comedic, a sporting goods brand could be sensitive to their product being used for slapstick violence.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 2,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Danster runs and grabs the basketball that's on the grass, then hands it to Bryan. Bryan throws it at Junior's head",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0386,
   "iab_runner_up": "1508: Retail > Sporting Goods Stores"
  },
  {
   "scene_id": "SC003",
   "page_number": 3,
   "raw_term": "Weekend at Bernies (referenced by Danster)",
   "normalized_iab_product": "cigar",
   "iab_category": "1545: Tobacco > Cigars",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "This is named intellectual property. The reference is to a film involving the comedic desecration of a corpse, which is dark humor and could be sensitive for the IP holder.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Yes, Ma, we'll Weekend at Bernies him into the car.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0177,
   "iab_runner_up": "1225: Consumer Packaged Goods > Pet Care > Cat/Dog Litter"
  },
  {
   "scene_id": "SC004",
   "page_number": 3,
   "raw_term": "WINE (Donna chugs it from the bottle)",
   "normalized_iab_product": "wine",
   "iab_category": "1007: Alcohol > Wine",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The character chugs wine directly from the bottle as a stress-relief mechanism before preparing to drive. This context of drinking to cope and potential drinking-and-driving is negative.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 3,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "chugs some WINE from inside the cabinet, drinking directly from the bottle.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0294,
   "iab_runner_up": "1232: Consumer Packaged Goods > Refrigerated > Refrigerated Beverages"
  },
  {
   "scene_id": "SC004",
   "page_number": 3,
   "raw_term": "car (Donna hopes it starts)",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The character expresses concern that her car might not start, implying it is unreliable. This is a negative context for an automotive placement.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 4,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Now let's pray the car starts--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0033,
   "iab_runner_up": "1553: Vehicles > Automotive Ownership"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "homemade habit (Danster is wearing it)",
   "normalized_iab_product": "costumes and accessories",
   "iab_category": "1069: Clothing and Accessories > Costumes and Accessories",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character wears a homemade religious habit as part of a comedic family portrait. The context is neutral and focuses on the character's quirkiness.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Danster is wearing the homemade habit.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0141,
   "iab_runner_up": "1239: Consumer Packaged Goods > Religious Items"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "brush (in Junior's hair, carried by a rat)",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The brush is first seen in a sleeping character's messy hair and is then carried away by a rat, creating a strong negative and unhygienic association.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 3,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "A small RAT scurries out of Junior's hair carrying the brush",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0367,
   "iab_runner_up": "1273: Durable Goods > Grooming Supplies > Hair Appliances"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "wine (Donna has wine-stained lips / wine mouth)",
   "normalized_iab_product": "wine",
   "iab_category": "1007: Alcohol > Wine",
   "integration_type": "Product Placement",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "Wine is mentioned in the context of a character drinking it before church, leading to stained lips. This implies overindulgence in a religious setting, which is sensitive for an alcohol brand.",
   "integration_density": 12,
   "mentions": 2,
   "scene_count": 3,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Does Ma have wine mouth again?",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0445,
   "iab_runner_up": "1197: Consumer Packaged Goods > Household/Plastics/Storage > Bottles"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "donation BASKET (passed around for collection)",
   "normalized_iab_product": "home and garden products",
   "iab_category": "1277: Durable Goods > Home and Garden Products",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The basket is central to the scene's action, but it becomes the receptacle for a box of cigarettes and baby vomit. This is a highly negative context.",
   "integration_density": 60,
   "mentions": 4,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "The donation BASKET starts being passed nearby.",
   "votes": "2/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.001,
   "iab_runner_up": "1373: Gifts and Holiday Items > Gift Baskets"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "purse (Donna forgot it at home)",
   "normalized_iab_product": "handbags and wallets",
   "iab_category": "1072: Clothing and Accessories > Handbags and Wallets",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The purse is mentioned as being forgotten, which serves as a neutral plot device to create the scene's central conflict.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "I forgot my purse at home",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0354,
   "iab_runner_up": "1239: Consumer Packaged Goods > Religious Items"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "donation check / voided CHECK (vomited by baby)",
   "normalized_iab_product": "cigarette",
   "iab_category": "1546: Tobacco > Cigarettes",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "A check, representing a financial service, is the subject of a comedic but disgusting reveal when a baby vomits it into a donation basket. This is a very negative association.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 3,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Cuddles vomits the voided CHECK into the basket.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0192,
   "iab_runner_up": "1337: Finance and Insurance > Banking"
  },
  {
   "scene_id": "SC005",
   "page_number": 3,
   "raw_term": "BOX OF CIGARETTES / cigs (Gerry puts in donation basket)",
   "normalized_iab_product": "cigarettes",
   "iab_category": "NCC \u2014 Tobacco product",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "This is a tobacco product, which is a non-commercial category (NCC). It is used as a comedic prop when a character donates it in church.",
   "integration_density": 0,
   "mentions": 2,
   "scene_count": 3,
   "review_flag": "NCC",
   "evidence_span": "a half-used BOX OF CIGARETTES.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "pencil (Danster is busy writing something with a pencil)",
   "normalized_iab_product": "office",
   "iab_category": "1203: Consumer Packaged Goods > Office/School Supplies",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character uses a pencil to write and then erase something on a piece of paper. The usage is standard and brief.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "Danster is busy writing something with a pencil.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0433,
   "iab_runner_up": "1020: Business and Industrial > Business Services > Office Equipment and Supplies"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "videogame (Bryan plays a videogame)",
   "normalized_iab_product": "video game consoles",
   "iab_category": "1121: Consumer Electronics > Video Game Consoles",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character is seen playing a videogame in the car. The usage is a background activity and does not affect the plot.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "Bryan plays a videogame.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0323,
   "iab_runner_up": "1249: Consumer Packaged Goods > Toys and Games > Games"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "FIRST WIVES CLUB (Danster wrote it as his dream job)",
   "normalized_iab_product": "cigar",
   "iab_category": "1545: Tobacco > Cigars",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "This is named intellectual property used as a comedic character reveal. The context is neutral but all IP is category sensitive.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|IAB_AMBIGUOUS",
   "evidence_span": "Danster wrote \u201cFIRST WIVES CLUB CHOREOGRAPHER.\u201d",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.011,
   "iab_runner_up": "1239: Consumer Packaged Goods > Religious Items"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "Marlboro (Gerry lights up a cigarette)",
   "normalized_iab_product": "Marlboro cigarettes",
   "iab_category": "NCC \u2014 Tobacco product",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "A character smokes a named brand of cigarette in a car with his family. This is a non-commercial category (tobacco).",
   "integration_density": 0,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "NCC",
   "evidence_span": "ya already got your Marlboro lit?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "van (Gerry complains about the piece of shit van)",
   "normalized_iab_product": "vehicle type",
   "iab_category": "1568: Vehicles > Vehicle Type",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The family's van is repeatedly called a 'piece of shit', described as smoking and breaking down, and it ultimately fails at the end of the scene. This is a very negative context for an automotive brand.",
   "integration_density": 60,
   "mentions": 4,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "This piece of shit van smokes more than me--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0264,
   "iab_runner_up": "1225: Consumer Packaged Goods > Pet Care > Cat/Dog Litter"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "magazines (Danster was selling them for school)",
   "normalized_iab_product": "motel",
   "iab_category": "1534: Travel and Tourism > Accommodations > Motels",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "Magazines are mentioned in passing as something a character was selling for a school fundraiser. The context is neutral.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "selling magazines for school.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0011,
   "iab_runner_up": "1430: Media > Magazines and Newspapers"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "Solon Motel Inn (where Rick was caught with a mortician)",
   "normalized_iab_product": "motel",
   "iab_category": "1534: Travel and Tourism > Accommodations > Motels",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The motel is mentioned as the location of an extramarital affair. This is a negative context for a hospitality brand.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "the Solon Motel Inn--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0685,
   "iab_runner_up": "1358: Food and Beverage Services > Fast Food"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "antihistamine (Donna asks if it made Junior hungry)",
   "normalized_iab_product": "doctor perscribed medicines",
   "iab_category": "1521: Sexual Health > Doctor Perscribed Medicines",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "An antihistamine is mentioned as a possible cause for a character's hunger and sleepiness, but it's implied he is actually high on marijuana. This association with drug use makes it category sensitive.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Did that antihistamine you had for your allergies make you hungry?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0111,
   "iab_runner_up": "1208: Consumer Packaged Goods > Over the Counter Medication"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "dehumidifier (Danster asks if Junior was using it)",
   "normalized_iab_product": "home and garden products",
   "iab_category": "1277: Durable Goods > Home and Garden Products",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "A dehumidifier is mentioned as a potential cover for a room being 'smokey,' implying it's being used to hide marijuana smoke. This association with drug use makes it category sensitive.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Were you using the dehumidifier for allergies yesterday?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.002,
   "iab_runner_up": "1196: Consumer Packaged Goods > Household/Plastics/Storage"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "Pauly Shore movies (Junior was watching them while high)",
   "normalized_iab_product": "entertainment memorabilia",
   "iab_category": "1079: Collectables and Antiques > Entertainment Memorabilia",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "This is named IP (an actor's body of work) mentioned in the context of a character watching them while high on marijuana. The association with drug use makes it category sensitive.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|IAB_AMBIGUOUS",
   "evidence_span": "laughing so hard watching Pauly Shore movies?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0041,
   "iab_runner_up": "1008: Culture and Fine Arts"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "A Beautiful Mind (visual comparison for Donna thinking)",
   "normalized_iab_product": "snack",
   "iab_category": "1175: Consumer Packaged Goods > General Food > Snacks",
   "integration_type": "Product Placement",
   "integration_type_llm": "Product Placement",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "This is named intellectual property used as a visual simile in an action line. The context is neutral but all IP is category sensitive.",
   "integration_density": 6,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|IAB_AMBIGUOUS",
   "evidence_span": "the visual makes her look like Russel Crowe in A Beautiful Mind.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "PRESENT_ONLY",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0209,
   "iab_runner_up": "1358: Food and Beverage Services > Fast Food"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "brazier (Donna wants to take it off)",
   "normalized_iab_product": "pantyhose",
   "iab_category": "1193: Consumer Packaged Goods > Hosiery > Pantyhose/Nylons",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character complains about her bra being uncomfortable and adjusts it. The context is comedic and relatable.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Donna adjusts her bra.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0052,
   "iab_runner_up": "1065: Clothing and Accessories > Clothing > Underwear and Lingerie"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "seatbelt (Donna asks if Junior is wearing his)",
   "normalized_iab_product": "automotive ownership",
   "iab_category": "1553: Vehicles > Automotive Ownership",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Positive",
   "suitability_reason": "A character expresses concern about her son wearing his seatbelt, promoting vehicle safety. This is a positive context.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Is he even wearing his seatbelt--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.021,
   "iab_runner_up": "1000: Ad Safety Risk"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "pot (Donna asks if Junior is doing it)",
   "normalized_iab_product": "marijuana",
   "iab_category": "NCC \u2014 Illegal drug",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "A character is accused of using marijuana. This is a non-commercial category (illegal drugs).",
   "integration_density": 0,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "NCC",
   "evidence_span": "You're not doing the pot, are you?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "mums (Danster asks to stop and get them for fall)",
   "normalized_iab_product": "home and garden products",
   "iab_category": "1277: Durable Goods > Home and Garden Products",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Positive",
   "suitability_reason": "A character expresses a desire to buy flowers for seasonal decoration. The context is positive and family-oriented.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "can we stop and get mums for fall?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.003,
   "iab_runner_up": "1372: Gifts and Holiday Items > Flowers"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "Home Depot (Gerry says he'll take Danster there)",
   "normalized_iab_product": "household",
   "iab_category": "1196: Consumer Packaged Goods > Household/Plastics/Storage",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Positive",
   "suitability_reason": "A father promises to take his son to Home Depot to buy flowers. This is a positive, family-oriented context for the brand.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "I'll take you to Home Depot later,",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0068,
   "iab_runner_up": "1502: Retail > Hardware Stores"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "American cheese (characters discuss its use)",
   "normalized_iab_product": "dairy",
   "iab_category": "1230: Consumer Packaged Goods > Refrigerated > Dairy",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "Characters discuss running out of cheese and how it's being used (microwaved on crackers vs. for burgers). The context is a neutral family discussion about food.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Stop microwaving that American cheese on crackers every night--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0157,
   "iab_runner_up": "1358: Food and Beverage Services > Fast Food"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "crackers (Junior microwaves cheese on them)",
   "normalized_iab_product": "cookies and crackers",
   "iab_category": "1172: Consumer Packaged Goods > General Food > Cookies and Crackers",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "Crackers are mentioned as part of a snack a character makes. The context is a neutral family discussion about food.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "American cheese on crackers every night--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0848,
   "iab_runner_up": "1358: Food and Beverage Services > Fast Food"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "burgers (Donna buys cheese for them)",
   "normalized_iab_product": "fast food",
   "iab_category": "1358: Food and Beverage Services > Fast Food",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "Burgers are mentioned as the intended use for a type of cheese. The context is a neutral family discussion about food.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "I buy it for burgers.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0225,
   "iab_runner_up": "1136: Consumer Packaged Goods > Beverages > Sports/Energy Drinks"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "Chinese food (the neighbors are stopping for it)",
   "normalized_iab_product": "fast food",
   "iab_category": "1358: Food and Beverage Services > Fast Food",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "Chinese food is mentioned as something the neighbors are getting for a meal. The context is neutral.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "Stopping for Chinese food, you guys wanna join?",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0368,
   "iab_runner_up": "1165: Consumer Packaged Goods > General Food"
  },
  {
   "scene_id": "SC006",
   "page_number": 4,
   "raw_term": "driving range (Rick suggests going next weekend)",
   "normalized_iab_product": "sporting events",
   "iab_category": "1325: Events and Performances > Sporting Events",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A driving range is mentioned as a place for a social outing between two characters. The context is neutral.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Driving range next weekend?",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0038,
   "iab_runner_up": "1524: Sporting Goods"
  },
  {
   "scene_id": "SC007",
   "page_number": 7,
   "raw_term": "POSTERS of Devon Sawa and JTT (line the walls)",
   "normalized_iab_product": "culture and fine arts",
   "iab_category": "1008: Culture and Fine Arts",
   "integration_type": "Product Placement",
   "integration_type_llm": "Product Placement",
   "segment_suitability": "Negative",
   "suitability_reason": "The posters are set dressing in a '90s bedroom. The scene is highly dramatic and negative, involving a homophobic slur and a character being outed against their will. Association with this content is sensitive for any IP.",
   "integration_density": 6,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|IAB_AMBIGUOUS",
   "evidence_span": "POSTERS of Devon Sawa and JTT line the walls.",
   "votes": "2/3",
   "script_block": "ACTION",
   "narrative_function": "PRESENT_ONLY",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "N",
   "iab_family_margin": 0.0001,
   "iab_runner_up": "1079: Collectables and Antiques > Entertainment Memorabilia"
  },
  {
   "scene_id": "SC007",
   "page_number": 7,
   "raw_term": "PAPER FORTUNE TELLER (AKA a Cootie Catcher) (used by characters)",
   "normalized_iab_product": "toys",
   "iab_category": "1252: Consumer Packaged Goods > Toys and Games > Toys",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The fortune teller is the central plot device. It is used to deliver an inappropriate message that causes the father to get angry, leading to a character being outed with a homophobic slur and storming out in tears.",
   "integration_density": 60,
   "mentions": 4,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Jojo are playing with a PAPER FORTUNE TELLER (AKA a Cootie Catcher)",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "N",
   "iab_family_margin": 0.0393,
   "iab_runner_up": "1527: Sporting Goods > Indoor Games Equipment"
  },
  {
   "scene_id": "SC007",
   "page_number": 7,
   "raw_term": "INFLATABLE CHAIR (Rick sits on it)",
   "normalized_iab_product": "furniture",
   "iab_category": "1268: Durable Goods > Furniture",
   "integration_type": "Product Placement",
   "integration_type_llm": "Product Placement",
   "segment_suitability": "Negative",
   "suitability_reason": "The chair is a piece of set dressing that a character sits on. It is present during a highly negative and dramatic scene involving a homophobic slur and a character being outed.",
   "integration_density": 6,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "Rick sits down on an INFLATABLE CHAIR to observe.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "PRESENT_ONLY",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "N",
   "iab_family_margin": 0.0258,
   "iab_runner_up": "1528: Sporting Goods > Outdoor Recreation Equipment"
  },
  {
   "scene_id": "SC007",
   "page_number": 7,
   "raw_term": "the Browns (NFL team)",
   "normalized_iab_product": "sporting events",
   "iab_category": "1325: Events and Performances > Sporting Events",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The NFL team is mentioned in dialogue as a point of connection between two characters. However, the scene culminates in a homophobic slur and a traumatic outing, making any brand association sensitive.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IP_PLACEMENT|IAB_AMBIGUOUS",
   "evidence_span": "do you know if the Browns won today?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "N",
   "iab_family_margin": 0.0002,
   "iab_runner_up": "1524: Sporting Goods"
  },
  {
   "scene_id": "SC007",
   "page_number": 7,
   "raw_term": "football (Danster and Rick discuss it)",
   "normalized_iab_product": "sport",
   "iab_category": "1136: Consumer Packaged Goods > Beverages > Sports/Energy Drinks",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The sport is mentioned as a topic of conversation that initially bonds two characters. The scene's context is highly negative due to a homophobic slur and a character being outed, making the association negative.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "You like football?",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "N",
   "iab_family_margin": 0.0047,
   "iab_runner_up": "1524: Sporting Goods"
  },
  {
   "scene_id": "SC008",
   "page_number": 8,
   "raw_term": "cigarette (in Gerry's mouth, mentioned, and lit)",
   "normalized_iab_product": "cigarette",
   "iab_category": "NCC \u2014 Tobacco product",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "This is a tobacco product, which is a non-commercial category (NCC). The character is seen with it, it is mentioned in dialogue, and he then lights it.",
   "integration_density": 0,
   "mentions": 3,
   "scene_count": 2,
   "review_flag": "NCC",
   "evidence_span": "cigarette in his mouth",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED|DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC008",
   "page_number": 8,
   "raw_term": "aviator sunglasses (worn by Gerry)",
   "normalized_iab_product": "sunglasses",
   "iab_category": "1074: Clothing and Accessories > Sunglasses",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The sunglasses are mentioned as part of a comedic character description by the auctioneer. The use is neutral and contributes to the scene's comedic tone.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": null,
   "evidence_span": "aviator sunglasses",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0457,
   "iab_runner_up": "1545: Tobacco > Cigars"
  },
  {
   "scene_id": "SC008",
   "page_number": 8,
   "raw_term": "short shorts (worn by Gerry)",
   "normalized_iab_product": "cigar",
   "iab_category": "1545: Tobacco > Cigars",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The shorts are mentioned as part of a comedic character description by the auctioneer. The use is neutral and contributes to the scene's comedic tone.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "short shorts",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0029,
   "iab_runner_up": "1074: Clothing and Accessories > Sunglasses"
  },
  {
   "scene_id": "SC008",
   "page_number": 8,
   "raw_term": "XL Chevy Caprice (car Gerry buys at auction)",
   "normalized_iab_product": "cigar",
   "iab_category": "1545: Tobacco > Cigars",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "A named vehicle is purchased by the main character, but it is explicitly associated with a death (\"formerly owned by someone who died inside it\"), which is a negative context for an automotive brand.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "The former XL Chevy Caprice",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0088,
   "iab_runner_up": "1553: Vehicles > Automotive Ownership"
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "Chevy Caprice CAR (Gerry's new, extra-long car)",
   "normalized_iab_product": "automotive ownership",
   "iab_category": "1553: Vehicles > Automotive Ownership",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The car is the source of a major family argument and the direct cause of the main character's destructive rage, as its excessive length leads him to demolish part of his garage.",
   "integration_density": 120,
   "mentions": 8,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Gerry pulls in the driveway in an extra-long Chevy Caprice",
   "votes": "2/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED|MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0808,
   "iab_runner_up": "1341: Finance and Insurance > Insurance > Auto Insurance"
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "ice cream (Danster asks to go get some)",
   "normalized_iab_product": "general food",
   "iab_category": "1165: Consumer Packaged Goods > General Food",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A child's request to get ice cream is used to highlight the new car and provide a moment of innocence amidst rising family tension. The context is neutral.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "Can we go get ice cream in the new car",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0165,
   "iab_runner_up": "1553: Vehicles > Automotive Ownership"
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "hat (Danster goes to grab his)",
   "normalized_iab_product": "hair spray",
   "iab_category": "1184: Consumer Packaged Goods > Hair Care > Hair Spray/Spritz",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character mentions grabbing his hat as part of an exit line. The context is entirely neutral.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "I'm gonna grab my hat--",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0137,
   "iab_runner_up": "1068: Clothing and Accessories > Clothing Accessories"
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "tool belt (Bryan gets it for Gerry)",
   "normalized_iab_product": "cigarette",
   "iab_category": "1546: Tobacco > Cigarettes",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The tool belt is requested and brought to a character immediately before he uses a tool from it to begin an act of angry destruction. The association is negative.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Bryan returns with a TOOL BELT for his dad.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0611,
   "iab_runner_up": "1277: Durable Goods > Home and Garden Products"
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "CIGARETTES (Gerry smokes one)",
   "normalized_iab_product": "cigarettes",
   "iab_category": "NCC \u2014 Tobacco product",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "A character smokes a cigarette while angry and contemplating a destructive act, portraying smoking as a response to stress.",
   "integration_density": 0,
   "mentions": 3,
   "scene_count": 3,
   "review_flag": "NCC",
   "evidence_span": "reaches into the car for one of his CIGARETTES.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "CABINETS (Gerry tears them down)",
   "normalized_iab_product": "furniture",
   "iab_category": "1268: Durable Goods > Furniture",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The cabinets are the object of the main character's rage and are violently destroyed on screen.",
   "integration_density": 30,
   "mentions": 2,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Gerry begins tearing down the cabinets.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0103,
   "iab_runner_up": "1196: Consumer Packaged Goods > Household/Plastics/Storage"
  },
  {
   "scene_id": "SC009",
   "page_number": 9,
   "raw_term": "HAMMER (Gerry removes it from his tool belt)",
   "normalized_iab_product": "home and garden products",
   "iab_category": "1277: Durable Goods > Home and Garden Products",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The hammer is the specific tool the character selects to carry out an act of angry destruction on his property.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "Gerry removes the HAMMER.",
   "votes": "3/3",
   "script_block": "CHARACTER",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0151,
   "iab_runner_up": "1404: Home and Garden Services > Home Improvement and Repair"
  },
  {
   "scene_id": "SC010",
   "page_number": 10,
   "raw_term": "WINE (Donna chugs it)",
   "normalized_iab_product": "wine",
   "iab_category": "1007: Alcohol > Wine",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Category Sensitive",
   "suitability_reason": "The product is consumed hastily ('chugs it') in a dramatic context, which could imply distress or alcoholism. This is a sensitive use case for an alcohol brand.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 3,
   "review_flag": "CAT_SENSITIVE|IAB_AMBIGUOUS",
   "evidence_span": "WINE from the refrigerator and chugs it",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0184,
   "iab_runner_up": "1232: Consumer Packaged Goods > Refrigerated > Refrigerated Beverages"
  },
  {
   "scene_id": "SC010",
   "page_number": 10,
   "raw_term": "refrigerator (Donna grabs wine from it)",
   "normalized_iab_product": "refrigerated beverages",
   "iab_category": "1232: Consumer Packaged Goods > Refrigerated > Refrigerated Beverages",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The refrigerator is used for its standard function of storing a beverage. The dramatic tone of the scene is related to the character's actions, not the appliance.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "WINE from the refrigerator",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "DEMONSTRATED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0089,
   "iab_runner_up": "1289: Durable Goods > Household Appliances"
  },
  {
   "scene_id": "SC011",
   "page_number": 10,
   "raw_term": "the car (Gerry tries to park it)",
   "normalized_iab_product": "automotive ownership",
   "iab_category": "1553: Vehicles > Automotive Ownership",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The car is the source of the scene's conflict and the character's frustration, as it is too large to fit in the garage. This is a negative context for an automotive brand.",
   "integration_density": 60,
   "mentions": 4,
   "scene_count": 4,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Gerry gets back into the car to pull in.",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED|DEMONSTRATED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0511,
   "iab_runner_up": "1196: Consumer Packaged Goods > Household/Plastics/Storage"
  },
  {
   "scene_id": "SC011",
   "page_number": 10,
   "raw_term": "Oreo Blizzard (Junior wants one)",
   "normalized_iab_product": "general food",
   "iab_category": "1165: Consumer Packaged Goods > General Food",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "A character requests this specific branded food item. The surrounding scene is tense, but the product itself is mentioned neutrally as a simple request.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "Junior said he wants an Oreo Blizzard",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0215,
   "iab_runner_up": "1358: Food and Beverage Services > Fast Food"
  },
  {
   "scene_id": "SC011",
   "page_number": 10,
   "raw_term": "box of cigarettes (Gerry is out and wants more)",
   "normalized_iab_product": "cigarettes",
   "iab_category": "NCC \u2014 Tobacco product",
   "integration_type": "NCC",
   "integration_type_llm": "NCC",
   "segment_suitability": "NCC",
   "suitability_reason": "This is a tobacco product, which is a non-commercial category. The character's craving and inability to find them contributes to his anger and his decision to leave.",
   "integration_density": 0,
   "mentions": 2,
   "scene_count": 3,
   "review_flag": "NCC",
   "evidence_span": "Go get me another box of cigarettes",
   "votes": "3/3",
   "script_block": "ACTION",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": "",
   "iab_runner_up": ""
  },
  {
   "scene_id": "SC012",
   "page_number": 10,
   "raw_term": "car (Gerry tries to return it)",
   "normalized_iab_product": "automotive ownership",
   "iab_category": "1553: Vehicles > Automotive Ownership",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The car is the central topic of a comedic conflict. A character wants to return it because it doesn't fit in his garage, which is presented as his own problem, not a fault of the car. This is a neutral context for an automotive brand.",
   "integration_density": 45,
   "mentions": 3,
   "scene_count": 4,
   "review_flag": null,
   "evidence_span": "I need to return the car I just bought.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0494,
   "iab_runner_up": "1203: Consumer Packaged Goods > Office/School Supplies"
  },
  {
   "scene_id": "SC012",
   "page_number": 10,
   "raw_term": "house (Gerry says it was designed with a small garage)",
   "normalized_iab_product": "automotive ownership",
   "iab_category": "1553: Vehicles > Automotive Ownership",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The house is mentioned as having a design flaw (a small garage), which is the source of the comedic problem. This is a neutral context for a home builder or real estate service.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "The builder who designed my house",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0002,
   "iab_runner_up": "1482: Real Estate"
  },
  {
   "scene_id": "SC012",
   "page_number": 10,
   "raw_term": "garage (Gerry says it's too small for his car)",
   "normalized_iab_product": "home and garden products",
   "iab_category": "1277: Durable Goods > Home and Garden Products",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Neutral",
   "suitability_reason": "The garage is mentioned as being too small, which is the source of the scene's comedic conflict. This is a neutral context, as the issue is with this specific garage's design, not garages in general.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 1,
   "review_flag": "IAB_AMBIGUOUS",
   "evidence_span": "made the garage really small.",
   "votes": "2/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED",
   "function_block_conflict": false,
   "scene_tone": "Comedic",
   "video_safety": "Y",
   "iab_family_margin": 0.0042,
   "iab_runner_up": "1396: Home and Garden Services"
  },
  {
   "scene_id": "SC013",
   "page_number": 10,
   "raw_term": "This one (a 1965 car for sale)",
   "normalized_iab_product": "automotive ownership",
   "iab_category": "1553: Vehicles > Automotive Ownership",
   "integration_type": "Narrative Integration",
   "integration_type_llm": "Narrative Integration",
   "segment_suitability": "Negative",
   "suitability_reason": "The car is the central focus of the scene, but it is explicitly described as having contained a dead body for a long time, resulting in a bad smell, and has not been cleaned. This is a very negative context for an automotive brand.",
   "integration_density": 15,
   "mentions": 1,
   "scene_count": 4,
   "review_flag": "CAT_SENSITIVE",
   "evidence_span": "This one didn't sell today, but it's available.",
   "votes": "3/3",
   "script_block": "DIALOGUE",
   "narrative_function": "MENTIONED|DECISION",
   "function_block_conflict": false,
   "scene_tone": "Dramatic",
   "video_safety": "Y",
   "iab_family_margin": 0.0438,
   "iab_runner_up": "1010: Business and Industrial"
  }
 ]
};

export default detoursRun;
